import autobind from 'autobind-decorator';
import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { classNames } from '../../utils/class-names.js';
import { __ } from '../../utils/i18n.js';
import { FormItem } from '../FormItem/FormItem.js';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const MAX_DATALIST_LENGTH = 15;
const SPLITED_DATALIST_LENGTH = 10;
class FormInput extends FormItem {
    handleValidate(value, allValues) {
        const { required } = this.props;
        if (required && (value === undefined || value === null || value === "" || Number.isNaN(value))) {
            return __("Az érték megadása kötelező!");
        }
        return super.handleValidate(value, allValues);
    }
    handlePrependClick() {
        if (this.inputElRef?.current) {
            if (typeof this.inputElRef.current.focus === "function") {
                this.inputElRef.current.focus();
            }
            if (typeof this.inputElRef.current.select === "function") {
                this.inputElRef.current.select();
            }
        }
    }
    handleAppendClick() {}
    getTestId() {
        const { id, name } = this.props;
        return id || name;
    }
    getInputProps(_fieldProps) {
        const { id = this.id, dataList, placeholder, required, readOnly, tabIndex, autoComplete, label, name } = this.props;
        let dataListId;
        if (dataList) {
            dataListId = `${(this.inputElRef?.current?.id || id || name) + this.id}-dataList`;
        }
        return {
            id,
            name,
            "aria-label": !label ? placeholder : undefined,
            autoComplete,
            placeholder,
            list: dataListId,
            tabIndex,
            readOnly,
            disabled: this.isDisabled(),
            required,
            "data-testid": this.getTestId(),
            onChange: (event)=>{
                this.handleChange(this.parse(event.currentTarget.value));
            },
            onBlur: (event)=>{
                this.handleBlur(event);
            },
            onFocus: (event)=>{
                this.handleFocus(event);
            }
        };
    }
    renderField(fieldProps, ref, additionalClass) {
        const { size: ctxSize } = this.context;
        const { id = this.id, size = ctxSize, name, dataList, flush } = this.props;
        const { input: { value } } = fieldProps;
        const inputGroupClass = classNames(flush && "input-group-flush", additionalClass);
        const dataListId = `${(this.inputElRef?.current?.id || id || name) + this.id}-dataList`;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InputGroup, {
            size: size,
            className: inputGroupClass
        }, this.renderPrepend(fieldProps, ref), this.renderInput(fieldProps, ref), this.renderAppend(fieldProps, ref)), this.renderDataList(dataListId, dataList, this.parse(value)));
    }
    renderPrepend(_fieldProps, _ref) {
        const { prepend } = this.props;
        return prepend && /*#__PURE__*/ React.createElement(InputGroup.Text, {
            onClick: this.handlePrependClick
        }, prepend);
    }
    renderInput(fieldProps, ref, additionalClass) {
        const { disabled, size } = this.props;
        const { input: { value }, meta: { invalid, touched } } = fieldProps;
        return /*#__PURE__*/ React.createElement(FormControl, {
            ...this.getInputProps(fieldProps),
            ref: ref,
            className: additionalClass,
            size: size,
            value: value,
            // isValid={!disabled && touched && valid}
            isInvalid: !disabled && touched && invalid
        });
    }
    renderAppend(_fieldProps, _ref) {
        const { append } = this.props;
        return append && /*#__PURE__*/ React.createElement(InputGroup.Text, {
            onClick: this.handleAppendClick
        }, append);
    }
    renderDataList(dataListId, dataList, value) {
        const { dataListLength = SPLITED_DATALIST_LENGTH } = this.props;
        if (dataList) {
            const typed = `${String(value)}`.toLowerCase();
            return /*#__PURE__*/ React.createElement("datalist", {
                id: dataListId
            }, dataList.filter((item)=>{
                const listItem = `${String(item)}`.toLowerCase();
                return !value && dataList.length < MAX_DATALIST_LENGTH || listItem.startsWith(typed) && listItem !== typed;
            }).slice(0, dataListLength).map((item)=>/*#__PURE__*/ React.createElement("option", {
                    "aria-label": String(item),
                    key: String(item),
                    value: String(item)
                })));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.inputElRef = /*#__PURE__*/ React.createRef();
    }
}
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof FieldType === "undefined" ? Object : FieldType,
        Object
    ]),
    _ts_metadata("design:returntype", Object)
], FormInput.prototype, "handleValidate", null);
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], FormInput.prototype, "handlePrependClick", null);
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], FormInput.prototype, "handleAppendClick", null);

export { FormInput };
//# sourceMappingURL=FormInput.js.map
